$(document).ready(function() {

	// home template scripts
	if ($('body').hasClass('page-template-page-prime-home')) {
		// initialize google places search
		autocomplete();
		initialSearchForm();
	}

	// testimonials slider
	if ($('.prime-testimonial').length > 1) {
		var testimonials = $('.prime-testimonials-group').flickity({
			adaptiveHeight: true,
			cellAlign: 'center',
			contain: true,
			pageDots: true,
			percentPosition: true,
			prevNextButtons: false,
			wrapAround: true
		});
	}

	// core values tabs/slider thing
	if ($('.prime-about-value').length > 1) {
		var values = $('.prime-about-values-slider').flickity({
			adaptiveHeight: true,
			cellAlign: 'center',
			contain: true,
			pageDots: false,
			percentPosition: true,
			prevNextButtons: false,
			wrapAround: true
		});
		$('.prime-value-menu-item').on('click', function(e) {
			e.preventDefault();
			var index = $(this).attr('data-slide-index');
			$('.prime-value-menu-item').removeClass('prime-value-menu-item-active');
			$(this).addClass('prime-value-menu-item-active');
			values.flickity('select', index, true, false);
		});
	}

	// launch team member modal
	$('.prime-team-member').on('click', function(e) {
		e.preventDefault();

		var thisTeamMember = $(this);

		$(thisTeamMember).prop('disabled', true);

		var teamMemberId = $(this).attr('data-id');
		$.ajax({
			type: 'post',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'prime_get_team_member_details',
				teamMemberId: teamMemberId
			},
			success: function(results) {
				var results = $.parseJSON(results);
				console.log(results);
				if (results.status == 'success') {
					var template = $($('#prime-team-member-modal-template').html());

					if (results.image_full) {
						$('.js-image img', template).attr({
							'src': results.image_full,
							'alt': results.image_alt
						});
					} else {
						$('.js-image', template).hide();
					}

					$('.js-name', template).html(results.name);

					if (results.biography) {
						$('.js-biography', template).html(results.biography);
					} else {
						$('.js-biography', template).hide();
					}

					if (results.phone_number || results.email_address || results.facebook_url || results.twitter_url || results.instagram_url || results.linkedin_url) {

						if (results.phone_number) {
							$('.js-phone-number a', template).attr({
								'href': 'tel:' + results.phone_number,
								'title': 'Call ' + results.name
							});
							$('.js-phone-number span', template).html(results.phone_number);
						} else {
							$('.js-phone-number', template).hide();
						}

						if (results.email_address) {
							$('.js-email-address a', template).attr({
								'href': 'mailto:' + results.email_address,
								'title': 'Email ' + results.name
							});
							$('.js-email-address psan', template).html(results.email_address);
						} else {
							$('.js-email-address', template).hide();
						}

						if (results.facebook_url) {
							$('.js-facebook-url a', template).attr({
								'href': results.facebook_url,
								'title': 'Follow ' + results.name + ' on Facebook'
							});
							$('.js-facebook-url span', template).html('Follow ' + results.name + ' on Facebook');
						} else {
							$('.js-facebook-url', template).hide();
						}

						if (results.twitter_url) {
							$('.js-twitter-url a', template).attr({
								'href': results.twitter_url,
								'title': 'Follow ' + results.name + ' on Twitter'
							});
							$('.js-twitter-url span', template).html('Follow ' + results.name + ' on Twitter');
						} else {
							$('.js-twitter-url', template).hide();
						}

						if (results.instagram_url) {
							$('.js-instagram-url a', template).attr({
								'href': results.instagram_url,
								'title': 'Follow ' + results.name + ' on Instagram'
							});
							$('.js-instagram-url span', template).html('Follow ' + results.name + ' on Instagram');
						} else {
							$('.js-instagram-url', template).hide();
						}

						if (results.linkedin_url) {
							$('.js-linkedin-url a', template).attr({
								'href': results.linkedin_url,
								'title': 'Connect with ' + results.name + ' on LinkedIn'
							});
							$('.js-linkedin-url span', template).html('Connect with ' + results.name + ' on LinkedIn');
						} else {
							$('.js-linkedin-url').hide();
						}

					} else {
						$('.js-social-menu', template).hide();
					}

					if (results.facts.facts) {

						if (results.facts.title) {
							$('.js-facts-title', template).html(results.facts.title);
						} else {
							$('.js-facts .prime-section-header', template).hide();
						}

						var facts = results.facts.facts;
						$(facts).each(function() {
							var fact = $($('#prime-team-member-facts-template').html());
							$('.js-fact-label', fact).html(this.label);
							$('.js-fact-text', fact).html(this.text);
							$('.js-facts-group', template).append(fact);
						});

					} else {
						$('.js-facts', template).hide();
					}

					$('body').append(template);
					$('body').addClass('prime-modal-active');
					$(thisTeamMember).prop('disabled', false);

				}
			},
			error: function(results) {
				var results = $.parseJSON(results);
				console.log(results);
				$('body').removeClass('prime-modal-active');
				$(thisTeamMember).prop('disabled', false);
			}
		});
	});

	$('body').on('click', '.prime-modal-close', function() {
		$('body').removeClass('prime-modal-active');
		$(this).parents('.prime-modal').remove();
	});

	// newsletter subscribe form
	$('#prime-newsletter-form').validate({
		// debug: true,
		errorElement: 'span',
		errorClass: 'form-field-error',
		validClass: 'form-field-valid',
		errorPlacement: function (error, element) {
			error.appendTo(element.parents('.form-field'));
		},
		highlight: function (element, errorClass, validClass) {
			$(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
		},
		rules: {
			'prime-newsletter-email': {
				required: true,
				email: true
			}
		},
		messages: {
			'prime-newsletter-email': {
				required: 'Please enter your email address.',
				email: 'Please enter a valid email address.'
			}
		},
		submitHandler: function(form) {

			$('.prime-submit-button', form).prop('disabled', true);

			var name = $('#prime-newsletter-name').val();
			var email = $('#prime-newsletter-email').val();
			var nonce = $('#prime-newsletter-form-nonce').val();

			$.post('/wp-content/themes/prime-parking/subscribe.php', { email: email }, function(results) {
				var results = JSON.parse(results);
				console.log(results);
				$('.prime-submit-button', form).prop('disabled', false);
				if (results.status == 'success') {
					$('.prime-newsletter-form-message').empty().removeClass('prime-newsletter-form-message-error').addClass('prime-newsletter-form-message-success').text(results.message);
				} else if (results.status == 'error') {
					var body = $.parseJSON(results.last_response.body);
					var errorTitle = body.title;
					var errorDetail = body.detail;
					var httpCode = results.last_response.headers.http_code;
					console.log(httpCode, errorTitle, errorDetail);
					console.log(body);
					if (errorTitle == 'Member Exists') {
						$('.prime-newsletter-form-message').empty().removeClass('prime-newsletter-form-message-success').addClass('prime-newsletter-form-message-error').text('Thanks, but you\'re already subscribed to our mailing list!');
					} else {
						$('.prime-newsletter-form-message').empty().removeClass('prime-newsletter-form-message-success').addClass('prime-newsletter-form-message-error').text(results.message);
					}
				} else {
					$('.prime-newsletter-form-message').empty().removeClass('prime-newsletter-form-message-success').addClass('prime-newsletter-form-message-error').text('Something went wrong. Please try again?');
				}
			});
		}
	});

});
